export const RPM_CONSENT_TYPE_OPTIONS = [
    { value: 'INBOUND', label: 'Inbound (patient called us)' },
    { value: 'OUTBOUND', label: 'Outbound (we called patient)' },
    { value: 'SELF_ENROLLED', label: 'Self / Digital' },
    { value: 'VIRTUAL_ASSISTANT_ENROLLED', label: 'Virtual Assistant-Enrolled' },
];
